import React, { useState, useEffect } from "react";
import Link from "next/link";
import { clientRoutes } from "helpers/clientRoutes";
import {
  getPatientAttributes,
  getPatientDetails,
} from "../../helpers/commonHelpers";
import clevertapTracking, { eventTracking } from "../../clevertapTracking";
import { useAuth } from "../../hooks/authHooks";
import { useRouter } from "next/router";
import useMobileDetect from "helpers/useMobileDetect";
import styles from "./Footer.module.scss";
import { dataLayerTracking } from "gtmTracking";

interface FooterUrlInterface {
  url: string;
  title: string;
}

interface FooterLinks {
  footerData?: {};
  className?: string;
  footerSize?: string;
  sectionName?: string;
}

const Footer: React.FC<FooterLinks> = (props) => {
  const { currentPatient } = useAuth();
  const patientDetails = getPatientDetails(currentPatient);
  const router = useRouter();
  const { footerData, footerSize, sectionName } = props;
  let footerKeys = [];
  if (footerData) {
    footerKeys = Object.keys(footerData);
  }
  const currentDevice = useMobileDetect();
  const [expandedKey, setExpandedKey] = useState<string>("");
  const [stateMobile, setStateMobile] = useState<boolean>(false);
  useEffect(() => {
    setStateMobile(currentDevice.isMobile());
  }, []);

  const handleClickFooterLinks = (item: string, link: FooterUrlInterface) => {
    dataLayerTracking({
      event: "footer_click",
      footer_name: link?.title,
      footer_section: item,
    });
  };

  return (
    <footer className={styles.footerContainer}>
      <div
        className={`${styles.container} ${
          footerSize ? styles[footerSize] : ""
        }`}
      >
        <div className={styles.footerContent}>
          <div className={styles.footerLogo}>
            <a
              onClick={(e) => {
                dataLayerTracking({
                  event: "icon_click",
                  icon_name: "Apollo247 Logo",
                  section_name: sectionName,
                });
                eventTracking("Home Page Icon Clicked", {
                  ...getPatientAttributes(patientDetails),
                  Nav_src: "Bottom bar",
                  URL: window.location.href,
                });
              }}
              title="Home"
              href={clientRoutes.welcome()}
              className={styles.logo}
            >
              <img
                src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_logo.png`}
                title={"Online Doctor Consultation & Medicines"}
                alt={"Online Doctor Consultation & Medicines"}
                width="100"
                height="75"
              />
            </a>
          </div>
          <div className={styles.accordionContainer}>
            {footerKeys &&
              footerKeys.map((currentItem: string, index: number) => {
                const key = `${currentItem}-${index}`;
                const open = !stateMobile || expandedKey === key;
                return (
                  <div className={styles.accordion} key={key}>
                    <div
                      className={styles.accordionHeader}
                      onClick={() =>
                        stateMobile &&
                        setExpandedKey(expandedKey === key ? "" : key)
                      }
                    >
                      <span
                        className={`${styles.expandIcon} ${
                          open ? styles.active : ""
                        }`}
                      ></span>
                      <h2 className={styles.title}>{currentItem}</h2>
                    </div>
                    <div
                      className={`${
                        open ? styles.accordionBody : styles.displayNone
                      }`}
                    >
                      <ul className={styles.footerLinks}>
                        {footerData[currentItem].map(
                          (currentLink: FooterUrlInterface) => {
                            return currentLink ? (
                              <li
                                key={currentLink.title}
                                onClick={() =>
                                  handleClickFooterLinks(
                                    currentItem,
                                    currentLink
                                  )
                                }
                              >
                                <a
                                  title={currentLink.title}
                                  key={currentLink.title}
                                  href={currentLink.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={() => {
                                    currentLink.url ===
                                      process.env.NEXT_PUBLIC_MEDICINE_URL &&
                                      eventTracking(
                                        "Pharmacy Home page viewed",
                                        {
                                          "Nav src": "Footer",
                                          "Page Name": router.asPath,
                                        }
                                      );
                                  }}
                                >
                                  {router.query.hasOwnProperty("variant")
                                    ? currentLink.title.replace(
                                        "Pharmacy",
                                        "Medicine"
                                      )
                                    : currentLink.title}
                                </a>
                              </li>
                            ) : null;
                          }
                        )}
                      </ul>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
